import { render, staticRenderFns } from "./DocumentThumbnail.vue?vue&type=template&id=7986596e&scoped=true"
import script from "./DocumentThumbnail.vue?vue&type=script&lang=js"
export * from "./DocumentThumbnail.vue?vue&type=script&lang=js"
import style0 from "./DocumentThumbnail.vue?vue&type=style&index=0&id=7986596e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7986596e",
  null
  
)

export default component.exports